export default __webpack_public_path__ + "static/media/fa-solid-900.4055b057.woff2";